import { ChangeDetectionStrategy, Component, TemplateRef, ViewEncapsulation, computed, contentChild, inject, input, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { rxHostPressedListener } from '@frontend/ui/rx-host-listener';

import { DsSegmentedControl } from './segmented-control.component';

// eslint-disable-next-line @nx/workspace-component-tests-present, @nx/workspace-component-default-story
@Component({
    selector: 'ds-segmented-option',
    template: ` <ng-content />`,
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DsSegmentedOption {
    private readonly segmentedControl = inject(DsSegmentedControl);

    public readonly title = input('');
    public readonly name = input.required<string>();

    public readonly selectOption = output<string>();

    public readonly customTemplate = contentChild<TemplateRef<any>>('dsTemplate');

    public readonly selected = computed(() => this.segmentedControl.selectedOption() === this);
    public readonly focusVisible = computed(() => this.segmentedControl.focusVisibleOption() === this);
    public readonly focused = computed(() => this.segmentedControl.focusedOption() === this);

    constructor() {
        rxHostPressedListener()
            .pipe(takeUntilDestroyed())
            .subscribe(() => this.selectOption.emit(this.name()));
    }
}
